import { createSlice } from "@reduxjs/toolkit";

const regFormSlice = createSlice({
  name: "regForms",
  initialState: {
    isFetching: false,
    regForms: [],
    error: []
  },
  reducers: {
    statusRegFormStart: (state) => {
      state.isFetching = false
      state.error = []
    },
    statusRegFormSuccess: (state, action) => {
      state.isFetching = false
      state.regForms = action.payload
      state.error = []
    },
    statusRegFormFailure: (state, action) => {
      state.isFetching = false
      state.error = action.payload
    }
  }
})


export const { 
  statusRegFormStart,
  statusRegFormSuccess,
  statusRegFormFailure 
} = regFormSlice.actions

export default regFormSlice.reducer